import React, { useState } from 'react';

import '../../styles/content-grid.scss';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import useCurrencyConverter from '@/hooks/useCurrencyConverter';

import { dayjs } from '../../../../../utils/dayjs-utils';
import CustomTooltip from '../../../../common-components/CustomTooltip/CustomTooltip';
import RequestUsageRightsModal from '../modals/RequestUsageRightsModal';
import ViewUsageRightsModal from '../modals/ViewUsageRightsModal';
import UsageRequestButton from '../UsageRequestButton';
import CommentSentimentTag from './CommentSentimentTag';

const CardBottom = ({ content }) => {
  const [showViewUsageRightsModal, setShowViewUsageRightsModal] = useState(false);
  const [showRequestUsageRightsModal, setShowRequestUsageRightsModal] = useState(false);

  const { convertToUserCurrency } = useCurrencyConverter();

  function openRequestUsageRequestModal() {
    setShowRequestUsageRightsModal(true);
  }

  function openViewUsageRequestModal() {
    setShowViewUsageRightsModal(true);
  }

  return (
    <>
      {showViewUsageRightsModal && (
        <ViewUsageRightsModal onClose={() => setShowViewUsageRightsModal(false)} post={content} />
      )}
      {showRequestUsageRightsModal && (
        <RequestUsageRightsModal onClose={() => setShowRequestUsageRightsModal(false)} post={content} />
      )}
      <div className="sl-card-bottom-container">
        {Boolean(content?.labels?.length) && (
          <div className="sl-card-label-container">
            {content?.labels?.map(({ color, _id, title }) => (
              <CustomTooltip title={title} placement="top">
                <div key={_id} style={{ backgroundColor: color }} className="sl-card-label-item" />
              </CustomTooltip>
            ))}
          </div>
        )}
        <Accordion
          disableGutters
          sx={{
            '&.MuiAccordion-root': {
              '::before': {
                content: 'none',
              },
            },
          }}>
          <AccordionSummary
            sx={{
              padding: '0px 12px 12px 12px',
              '& .Mui-expanded': { minHeight: 'auto' },
              '& .MuiAccordionSummary-content': {
                margin: 0,
              },
              '&.MuiAccordionSummary-root': {
                minHeight: 'auto',
                borderTopWidth: 0,
              },
              '&.Mui-expanded': {
                borderBottom: '1px solid var(--border-default)',
              },
            }}
            expandIcon={<ExpandMoreIcon className="arrow-icon" color="#424242" sx={{ fontSize: '20px' }} />}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}>
              <UsageRequestButton
                status={content?.usageRightStatus}
                openView={openViewUsageRequestModal}
                openCreate={openRequestUsageRequestModal}
              />
              <div className="sl-view-stat-accordion">View Stats.</div>
            </div>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <div className="sl-card-details">
              <div className="summarized-section">
                <div className="summarized-section-item">
                  <div className="label">Date Posted</div>
                  <div className="value">
                    {content?.creativeCreatedDate
                      ? dayjs(content?.creativeCreatedDate).format('Do MMM, YYYY h:mm A')
                      : '-'}
                  </div>
                </div>
                {content?.type !== 'story' && (
                  <div className="summarized-section-item">
                    <div className="label">Engagement Rate</div>
                    <div className="value">
                      {content?.engagementRate && (
                        <div className="eng-rate-container">{content?.engagementRate?.toFixed(2)}%</div>
                      )}
                    </div>
                  </div>
                )}
                <div className="summarized-section-item">
                  <div className="label">Content Value</div>
                  <div className="value">
                    {content?.contentValue ? convertToUserCurrency(content?.contentValue).formatted : '-'}
                  </div>
                </div>
                {!['story', 'ttVideo'].includes(content?.type) && (
                  <div className="summarized-section-item">
                    <div className="label">Comment Sentiment</div>
                    <CommentSentimentTag
                      sentiment={content?.sentiment?.toLowerCase()}
                      comments={content?.comments}
                      type={content.type}
                    />
                  </div>
                )}
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

export default CardBottom;
